import { Trans } from '@lingui/react'
import { bool, func, node, shape, string } from 'prop-types'

import Modal from 'views/components/molecules/Modal'
import AddressForm from 'views/components/organisms/AddressForm'
import { DUMMY_SELLER_ID } from 'views/consts'

import './AddressModal.scss'

const AddressModal = ({
  addressId,
  modalId,
  title,
  open,
  size,
  type,
  csrfToken,
  initialFormValues,
  cartHasRXEntries,
}) => {
  return (
    <Modal
      {...{
        id: modalId,
        size,
        title: title || <Trans id="modal.address.title" />,
        open,
      }}
      isClientSideControlled
    >
      <AddressForm
        {...{
          addressId,
          cartHasRXEntries,
          type,
          initialFormValues,
          csrfToken,
          modalId,
        }}
      />
    </Modal>
  )
}

AddressModal.propTypes = {
  addressId: string,
  modalId: string.isRequired,
  size: string.isRequired,
  title: node,
  open: bool,
  type: string.isRequired,
  handleSubmit: func,
  handleReset: func,
  handleChange: func,
  formValues: shape({}),
  csrfToken: string,
  cartHasRXEntries: bool,
  initialFormValues: shape({}),
}

AddressModal.defaultProps = {
  addressId: DUMMY_SELLER_ID,
  title: null,
  open: false,
  handleSubmit: null,
  handleReset: null,
  handleChange: null,
  formValues: null,
  csrfToken: undefined,
  cartHasRXEntries: false,
  initialFormValues: {},
}

export default AddressModal
